import { useState, useEffect } from 'react'
import Icon24 from 'builder/components/Icon'
import { TooltipV2 } from 'builder/components/Tooltip'

import { useI18n } from 'builder/hooks/useI18n'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'

import { TRANSLATION } from '../constants'
import { useCoachBanner } from '../hooks/useCoachBanner'
import { BookButton, Container, HorizontalLine } from './styles'

const TOOLTIP_TIMEOUT = 3800
const KEY = 'book_coach_button_tooltip_seen'

export const BookCoachButton = () => {
  const { i18n } = useI18n()
  const { isPhone } = useMediaQueries()
  const { handleBookCoachButton } = useCoachBanner()

  const isTooltipSeen = localStorage.getItem(KEY)
  const [isTooltipVisible, setIsTooltipVisible] = useState(!isTooltipSeen)

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsTooltipVisible(false)
      localStorage.setItem(KEY, 'true')
    }, TOOLTIP_TIMEOUT)
    return () => clearTimeout(timeout)
  }, [])

  return (
    <Container>
      <TooltipV2
        multiline
        width={210}
        visible={isTooltipVisible}
        value={i18n.t(`${TRANSLATION}.tooltip`)}
      >
        <div>
          <BookButton onClick={handleBookCoachButton}>
            <Icon24.Conversation />
            {!isPhone && i18n.t(`${TRANSLATION}.actions.book_coach`)}
          </BookButton>
        </div>
      </TooltipV2>
      <HorizontalLine />
    </Container>
  )
}
